export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/movie_trailers.470e77b.svg";